<template>
  <basic-container>
    <div class="stockwrap">
      <div v-bind="stockData" class="stockMain" id="printBox">
        <h1 class="stockMain title" id="printTitle" style="font-weight: Medium;color:#333;">
          出货单
        </h1>
        <div class="stockMain content" id="content">
          <table border style="width:100% ;text-align:left;">
            <tr>
              <th style="width:300px">出货单编号:</th>
              <th style="width:300px;">{{ stockData.shipmentNum }}</th>
              <th style="width:300px">商户名称:</th>
              <th style="width:300px">{{ stockData.shopName }}</th>
            </tr>
            <tr>
              <th style="width:300px">出货时间:</th>
              <th style="width:300px">
                {{ handleFormatterDateToUTC(stockData.createTime) }}
              </th>
              <th style="width:300px">商品数量共计:</th>
              <th style="width:300px">{{ stockData.totalNumber }}</th>
            </tr>
          </table>

          <h2 class="stockMain title" id="printTitle" style="font-weight: Medium;color:#333;">
            出货明细
          </h2>
          <el-table :data="tableData" border style="text-align: left;" :span-method="mergeRows">
            <el-table-column prop="name" label="产品名称"></el-table-column>

            <!-- <el-table-column label="属性">
              <template slot-scope="scope">
                <div v-for="(attribute, index) in scope.row.attributes" :key="index">
                  {{ attribute }}
                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="属性">
              <template slot-scope="scope">
                <div v-for="(attribute, index) in scope.row.attributes" :key="index">
                  <span>{{ attribute.name }}: {{ attribute.value }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="amount" label="出货量"></el-table-column>
            <el-table-column prop="unit" label="单位"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  invoiceSystemV2PurchaseDetail1,
} from "@/api/salesCloud/stockRemoval";
import { stockFormOption } from "@/const/salesCloud/stockFormOption";
import VueQr from "vue-qr";
import { formatterDateToUTC } from "@/util/util";

export default {
  name: "stockRemoval",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: stockFormOption,
      tableData: [],
      tableLoading: false,
      tableHeaders: [],
      stockData: {},
    };
  },
  created() {
    let rowId = this.$route.query.id;
    this.dialogLook(rowId);
  },
  watch: {},
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    dialogLook(rowId) {
      invoiceSystemV2PurchaseDetail1(rowId).then((res) => {
        let data = JSON.parse(res.data);
        this.stockData = data;
        this.tableData = this.formatTableData(data.goodsResponseList);
        this.tableLoading = false;
      });
    },
    /* formatTableData(goodsList) {
      let formattedData = [];
      goodsList.forEach((item) => {
        if (item.dataSku) {
          item.dataSku.forEach((sku) => {
            let skuValues = sku.skuValue.split(':');
            let attributes = item.skuConstitute.map((constitute, index) => `${constitute.constituteName}:${skuValues[index]}`);
            formattedData.push({
              name: item.name,
              unit: item.unit,
              attributes: attributes,
              salePrice: sku.salePrice,
              amount: sku.amount
            });
          });
        } else {
          formattedData.push({
            name: item.name,
            unit: item.unit,
            attributes: ['N/A'],
            salePrice: 'N/A',
            amount: 'N/A'
          });
        }
      });
      return formattedData;
    }, */
    formatTableData(goodsList) {
      let formattedData = [];

      goodsList.forEach((item) => {
        if (item.dataSku) {
          item.dataSku.forEach((sku) => {
            let skuValues = sku.skuValue.split(':');
            let attributes = item.skuConstitute.map((constitute, index) => ({
              name: constitute.constituteName,
              value: skuValues[index]
            }));

            let existingItem = formattedData.find((existingItem) => {
              return (
                existingItem.name === item.name &&
                JSON.stringify(existingItem.attributes) === JSON.stringify(attributes)
              );
            });

            if (existingItem) {
              existingItem.amount += sku.amount;
            } else {
              formattedData.push({
                name: item.name,
                unit: item.unit,
                attributes: attributes,
                salePrice: sku.salePrice,
                amount: sku.amount
              });
            }
          });
        } else {
          formattedData.push({
            name: item.name,
            unit: item.unit,
            attributes: [{ name: 'N/A', value: 'N/A' }],
            salePrice: 'N/A',
            amount: 'N/A'
          });
        }
      });
      console.log(formattedData);
      return formattedData;
    },


    mergeRows({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.name === this.tableData[rowIndex - 1].name) {
          return {
            rowspan: 0,
            colspan: 0,
            display: 'none'
          };
        } else {
          let count = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].name === row.name) {
              count++;
            } else {
              break;
            }
          }
          return {
            rowspan: count,
            colspan: 1
          };
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.stockwrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .stockMain {
    height: 100%;

    .title {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      margin: 20px 0;
    }

    .content {
      padding: 20px;

      table {
        border-collapse: collapse;
        border: 1px solid #ebeef5;

        th {
          border: 1px solid #ebeef5;
          padding: 10px;
        }

        td {
          border: 1px solid #ebeef5;
          padding: 10px;
        }
      }
    }
  }
}
</style>